"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TENCENT_APP_ID = exports.CAPTCHA_URL = exports.CAPTCHA_TYPE = void 0;
/*
 * @Author: liujunhong
 * @Date: 2022/9/24
 * @Desc:
 */
// 腾讯云滑动验证码appId
var TENCENT_APP_ID = '2075382095';
// 验证码
exports.TENCENT_APP_ID = TENCENT_APP_ID;
var CAPTCHA_URL = '//validation2.gyyx.cn/captcha-route.js';
// 验证码类型
exports.CAPTCHA_URL = CAPTCHA_URL;
var CAPTCHA_TYPE = {
  gy: 'gyyx',
  tencent: 'tenyun',
  gycl: 'gycl',
  gywd: 'gywd',
  gySimple: 'gySimple'
};
exports.CAPTCHA_TYPE = CAPTCHA_TYPE;